import React, { useMemo } from "react";
import { Dictionary } from "lodash";
import { DimensionWithScores } from "@/features/people/hooks/useDimensionsWithScores";
import { ContentSection, FlowingContent } from "../../../generator";
import { DimensionContext } from "@/types/data";
import { ProfileValuesSection } from "@/features/profile/components/ProfileValuesSection";
import { useProfileCompletion } from "@/features/profile/hooks/useProfileCompletion";
import { useValuesInsights } from "@/shared/hooks/insights/useValuesInsights";
import { PdfInsightsSection } from "../../../components/PdfInsightGroupSection";
import { Person } from "@/features/people/graphql/generated";
import { BaseInsight } from "@/shared/hooks/insights/Insight.types";

interface ValuesProps {
  dimensions: Dictionary<DimensionWithScores[]>;
  context: DimensionContext;
  defaultPersonId?: number;
  person?: Person;
}

function Values(props: ValuesProps) {
  const { dimensions, context, defaultPersonId, person } = props;
  const { valuesComplete } = useProfileCompletion(dimensions);

  const insights = useValuesInsights({
    dimensions: dimensions.values,
    context,
    defaultPersonId,
  });

  const InsightsSections = useMemo(() => {
    return (
      <PdfInsightsSection
        groupedInsights={insights as Record<string, BaseInsight[]>}
        person={person}
      />
    );
  }, [insights, person]);

  if (!valuesComplete) return null;

  return (
    <>
      <ContentSection>
        <ProfileValuesSection
          dimensions={dimensions.values}
          isPdf
          context={context}
          defaultPersonId={defaultPersonId}
        />
      </ContentSection>
      <FlowingContent>{InsightsSections}</FlowingContent>
    </>
  );
}

export { Values };
